/**
 * Empty state: a surface that loaded correctly and has nothing to show.
 *
 * Deliberately a separate component from `ErrorState`. In the old app a search
 * returning zero results set the same error string as an API failure and rendered
 * it in the danger colour, so "nothing matched" and "the request failed" looked
 * identical.
 *
 * Audit references prevented here: nearby.jsx #6, food.jsx #20.
 *
 * @param {object} props
 * @param {string} props.title
 * @param {string} [props.description]
 * @param {import('react').ReactNode} [props.action]
 */
export function EmptyState({ title, description, action }) {
  return (
    <div className="state-block">
      <p className="state-block__title">{title}</p>
      {description ? <p className="state-block__body">{description}</p> : null}
      {action ? <div className="state-block__action">{action}</div> : null}
    </div>
  );
}
